"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _notification = _interopRequireDefault(require("britive-design-system/core/components/notification"));

var _ProgressBar = _interopRequireDefault(require("britive-design-system/core/components/progress-bar/ProgressBar"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _io = require("react-icons/io5");

var _IoReload = _interopRequireDefault(require("../../assets/IoReload.svg"));

var _utils = require("../../packages/my-secrets/modules/secrets/utils");

var _commonUtils = require("../../utils/common-utils");

var _action = require("../notification/action");

var _constants = require("./constants");

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.sm-secrets-otp-field-container {\n  margin-top: 2rem;\n  margin-bottom: 2rem; }\n  .sm-secrets-otp-field-container .sm-secrets-otp-heading-container {\n    display: flex;\n    justify-content: space-between; }\n    .sm-secrets-otp-field-container .sm-secrets-otp-heading-container .sm-secrets-otp-field-name {\n      display: flex; }\n    .sm-secrets-otp-field-container .sm-secrets-otp-heading-container .sm-secrets-otp-copy-button {\n      display: flex; }\n  .sm-secrets-otp-field-container .sm-secrets-otp-value-text {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 0.5rem; }\n  .sm-secrets-otp-field-container .sm-secrets-otp-loading-error {\n    width: fit-content;\n    margin-bottom: 1rem;\n    margin-top: 1rem; }\n  .sm-secrets-otp-field-container .sm-secrets-otp-timer-clock {\n    display: flex; }\n";
  var fileName = "compone_OTPRenderer";
  var element = document.querySelector("style[data-sass-component='compone_OTPRenderer']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var OTPRenderer = function OTPRenderer(_ref) {
  var fetchNewOTP = _ref.fetchNewOTP,
      selectedItemAncestors = _ref.selectedItemAncestors,
      otp = _ref.otp,
      secretOTPFetchStatus = _ref.secretOTPFetchStatus,
      secretOTPFetchLoadTime = _ref.secretOTPFetchLoadTime,
      reloadTime = _ref.reloadTime,
      initialLoadingTime = _ref.initialLoadingTime;

  var _useState = (0, _react.useState)(reloadTime - initialLoadingTime),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (time === 0) {
      fetchNewOTP(selectedItemAncestors);
    } else {
      setTimeout(function () {
        setTime(time - 1);
      }, 1000);
    }
  }, [time]);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(secretOTPFetchStatus)) {
      if (time === 0) {
        setTime(30 - secretOTPFetchLoadTime);
      }
    }
  }, [secretOTPFetchStatus]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpFieldContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpFieldHeadingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpFieldName
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "OTP"))), !(0, _commonUtils.isError)(secretOTPFetchStatus) && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpValueText
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, !(0, _commonUtils.isLoading)(secretOTPFetchStatus) ? otp : 'Fetching otp...'), time > 0 && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: 'textOnly',
    onClick: function onClick() {
      var toBeCopiedValue = (0, _utils.secretValueCopyHandler)({
        value: _defineProperty({}, _commonUtils.otpName, otp)
      }, {
        name: _commonUtils.otpName
      });
      toBeCopiedValue && navigator.clipboard.writeText(toBeCopiedValue);
      toBeCopiedValue && dispatch((0, _action.openNotification)('success', 'OTP copied', 3000));
    },
    size: 'small'
  }, /*#__PURE__*/_react.default.createElement(_io.IoCopyOutline, {
    size: 18
  }))), time > 0 && !(0, _commonUtils.isError)(secretOTPFetchStatus) && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpFieldTimer
  }, /*#__PURE__*/_react.default.createElement(_ProgressBar.default, {
    progressPercentage: time / 30 * 100,
    displayValue: "".concat(time, "s"),
    width: 200,
    height: 8
  })), (0, _commonUtils.isError)(secretOTPFetchStatus) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.otpLoadingError
  }, /*#__PURE__*/_react.default.createElement(_notification.default, {
    type: 'error',
    title: 'Unable to fetch OTP',
    open: open,
    inPlace: true,
    position: 'left'
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "primary",
    size: "small",
    onClick: function onClick() {
      return fetchNewOTP(selectedItemAncestors);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _IoReload.default,
    alt: "Reload",
    style: {
      marginRight: '0.5rem'
    }
  }), "Reload")));
};

OTPRenderer.propTypes = {
  fetchNewOTP: _propTypes.default.func,
  selectedItemAncestors: _propTypes.default.any,
  otp: _propTypes.default.string,
  secretOTPFetchStatus: _propTypes.default.string,
  reloadTime: _propTypes.default.number,
  initialLoadingTime: _propTypes.default.number,
  secretOTPFetchLoadTime: _propTypes.default.number
};
var _default = OTPRenderer;
exports.default = _default;